<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()" />
		</div>
		<div class="left-card balance-card">
			<div>拉新钱包</div>
			<div class="money-contain">
				<div style="font-size: 20px;">{{ invite.invite_money }}元</div>
				<div class="money-right">
					<span @click="$router.push('/inviteWithdrawal')">提现</span>
					<span @click="$router.push('/moneybag')">明细</span>
				</div>
			</div>
		</div>
		<div class="right-card balance-card">
			<div>今日新人激活</div>
			<div class="money-contain">
				<div style="font-size: 20px;">{{ invite.invite_num }}人</div>
			</div>
		</div>
		<div class="invitation-code-box">
			<div class="code-left">
				<img loading="lazy" class="qrcode" :src="data.share_image_url" alt="">
			</div>
			<div class="code-right">
				<div class="code-display">我的邀请码:{{ data.invitation_code }}</div>
				<div class="code-btn">
					<button @click="copyCode" class="btn">复制邀请码</button>
					<button @click="copyLink" class="btn">复制推广链接</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Fetch from '../../utils/fetch';
	export default {
		name: "investNew",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: {},
				invite: {},
			}
		},
		created() {
			this.$parent.footer('item', false);
			this.start();
			this.getInvite();
		},
		mounted() {
			
		},
		methods: {
			start() {
				Fetch('/user/myTeam').then((r) => {
					this.data = r.data;
				});
			},
			getInvite() {
				Fetch('/user/invite').then((r) => {
					this.invite = r.data;
				});
			},
			copyCode() {
			    navigator.clipboard.writeText(this.data.invitation_code).then(() => {
			        this.$toast({
			            className: "toastName",
			            message: "邀请码复制成功",
			        });
			    });
			},
			copyLink() {
			    navigator.clipboard.writeText(this.data.share_link).then(() => {
			        this.$toast({
			            className: "toastName",
			            message: "推广链接复制成功",
			        });
			    });
			}
		}
	}
</script>

<style lang="less" scoped>

	.red_top_bg {
		position: fixed;
		top: 0;
		z-index: 10;
		// background-color: #e40611;
		// background-image: linear-gradient(to right, #ff5252, #ff8244);

		.msg {
			position: absolute;
			top: 15px;
			right: 15px;
			height: 18px;

			img {
				height: 100%;
			}
		}
	}

	.basic_wrap {
		position: relative;
		background-image: url(../images/user/invitebg.png);
		background-repeat: round;
		background-size: contain;
		height: 720px;
	}

	.flex_bd {
		flex: 1;
	}

	.left-card {
		position: absolute;
		left: 32%;
		transform: translateX(-50%);
		width: 165px;
		// box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		// border-radius: 8px;
		padding: 15px;
		box-sizing: border-box;
		font-size: 15px;
		text-align: center;
	}

	.right-card {
		position: absolute;
		right: 30%;
		transform: translateX(50%);
		width: 165px;
		// box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		// border-radius: 8px;
		padding: 15px;
		box-sizing: border-box;
		font-size: 15px;
		text-align: center;
	}

	.balance-card {
		z-index: 10;
		color: #fff;
		top: 20%;
		height: 80px;
	}

	.money-contain {
		display: flex;
		flex-direction: column;
		// justify-content: space-between;
		// align-items: center;
		margin-top: 10px;

		.money-right {
			margin-top: 10px;
		}

		span {
			width: 58px;
			display: inline-block;
			// background: #000;
			/* line-height: 2; */
			height: 20px;
			text-align: center;
			line-height: 20px;
			border-radius: 10px;
			font-size: 12px;
			// color: #FFFFFF;
		}

		span:nth-child(1) {
			// border: 1px solid #fff;
			// height: 20px;
			background: #eed0d2;
			color: #000;
			margin-right: 10px;
		}

		span:nth-child(2) {
			background: #eed0d2;
			color: #000;
		}
	}

	.invitation-code-box {
		display: flex;
		background: rgba(255, 255, 255, 0.15);
		border-radius: 8px;
		// padding: 0 12px;
		text-align: center;
		// margin-bottom: 20px;
		position: absolute;
		top: 85%;
		width: 74%;
		left: 13%;

		.qrcode {
			object-fit: inherit;
			max-width: 74px !important;
			max-height: 74px !important;
			width: 74px !important;
			height: 74px !important;
		}

		.code-right {
			flex: 1;
		}
	}

	.code-left {
		width: 74px;
		height: 74px;
		padding-top: 5px;
		/* overflow: hidden; */
	}

	.code-display {
		color: #fff;
		width: 197px;
		padding-top: 5px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		font-size: 12px;
		font-weight: bold;
		/* margin-bottom: 12px; */
		letter-spacing: 2px;
	}

	.code-btn {
		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.btn {
		background: #fff;
		color: #d82b2b;
		border: none;
		width: 75%;
		border-radius: 15px;
		padding: 8px 12px;
		margin-top: 5px;
		cursor: pointer;
		font-weight: bold;
		transition: background-color 0.3s;
	}

	.btn:hover {
		background: #f0f0f0;
	}
</style>